export default {
  skip_to_main_content: 'Aller au contenu principal',
  hi_im_neela: 'Bonjour, je suis Neela,',
  aareons_virtual: 'votre assistante digitale.',
  english: 'English',
  german: 'Deutsch',
  french: 'Français',
  dutch: 'Nederlands',
  swedish: 'Sweden',
  media: 'Médias',
  media_link: 'https://neela.aareon.fr/media',
  contact: 'Contact',
  contact_link: 'https://neela.aareon.fr/contact',
  privacy: 'Déclaration de confidentialité',
  privacy_link:
    'https://www.aareon.fr/Declaration_de_confidentialite.90388.html',
  terms_of_use: "Conditions générales d'utilisation",
  terms_of_use_link:
    'https://www.aareon.fr/Conditions_generales_d_utilisation.250752.html',
  legal_notice: 'Mentions légales',
  legal_notice_link: 'https://neela.aareon.fr/legal',
  show_system_messages: 'Afficher les messages du système',
  dont_show_system_messages: 'Masquer les messages système',
  logged_in: 'Le locataire est authentifié',
  logged_out: 'Utilisateur anonyme',
  button_tooltip_switch_locale: 'Changer de lieu',
  button_tooltip_activate_voice_recognition: 'Activer la reconnaissance vocale',
  date_input: 'Choisir date',
  choose_two_dates: 'Choisissez deux dates',
  date_range: 'Plage de dates',
  from: 'de',
  to: 'à',
  avatar: 'Avatar',
  exit: 'Fermer',
  new: 'Nouveau',
  back: 'Retour',
  address: 'Adresse',
  suggestions: 'Suggestions',
  senton: 'Envoyé le',
  message_placeholder: 'Tapez votre message ici...',
  message_aria: 'Tapez votre message ici',
  upload_in_progress: 'Téléchargement en cours...',
  comment_placeholder: 'Entrez un commentaire ici',
  message_button_label: 'Envoyer',
  please_confirm: 'Veuillez confirmer',
  no: 'Non',
  yes: 'Oui',
  modal_delete_session: 'Supprimer session',
  modal_delete_session_notification:
    "Si vous fermez la fenêtre, votre session sera également supprimée. <br>Êtes-vous d'accord ?",
  template_contact_time: 'Quand pouvons-nous vous contacter ?',
  template_pause:
    "Votre séance a été interrompue. Un membre de notre personnel de soutien s'occupera de votre demande dans les plus brefs délais.",
  template_continue_after_pause:
    "Votre session s'est poursuivie. Vous pouvez maintenant continuer à écrire avec notre agent virtuel.",
  choose_date: 'Veuillez choisir une date',
  button_apply: 'Appliquer',
  button_cancel: 'Suspendre',
  none: 'Aucun',
  book_appointment: 'Prendre rendez-vous',
  address_input: "Entrée d'adresse",
  privacy_policy: 'politique de confidentialité',
  data_processing: 'Traitement des données',
  data_processing_notification_before_link:
    'Pour utiliser ce service de chat, il est nécessaire que vous acceptiez la ',
  data_processing_notification_after_link: '.',
  button_accept: 'Accepter',
  select_date: 'Choisir date',
  rate_conversation: 'Comment évalueriez-vous cette conversation?',
  new_ticket_question:
    'Y a-t-il autre chose que je puisse faire pour vous aider ?',
  thank_you:
    "Merci pour votre soutien. Vos commentaires m'aident à m'améliorer constamment.",
  goodbye: 'À bientôt',
  start_new: 'Commencer nouvelle conversation',
  operator_entered_the_chat: "L'opérateur est entré dans le chat",
  operator_left_the_chat: "L'opérateur a quitté le chat",
  bg_image: process.env.VUE_APP_FR_BG,
  expand_quickreplies: 'Plus',
  collapse_quickreplies: 'Moins',
  login: 'Connexion',
  logout: 'Déconnexion',
  close: 'Fermer',
  messenger_text: 'Vous pouvez soit écrire avec notre chatbot, soit contacter directement l\'un de nos employés dans notre chat en direct.',
  chat_bot: 'Chat Bot',
  live_bot: 'Live Chat',
  maximize: 'Maximiser',
  minimize: 'Minimiser',
  upload_file: 'Déposez le fichier ici pour le télécharger',
  upload_file_or: 'ou',
  Upload_file_select: 'Ajouter des fichiers',
  upload_file_text: 'Déposez le fichier pour le télécharger',
  show_attachments: 'Afficher la pièce jointe',
  hide_attachments: 'Masquer la pièce jointe',
  tooBig: 'Le fichier est trop grand',
  tooSmall: 'Le fichier est trop petit',
  invalidFileTypeCopilot:
    'Type de fichier invalide. Actuellement, seuls les types de fichiers .png, .jpg, .jpeg, .gif sont pris en charge.',
  tooManyFiles: 'Veuillez télécharger un maximum de 10 fichiers à la fois',
  uploadError: 'Échec du téléchargement. Veuillez réessayer.',
  maxDocumentsReached: 'Nombre maximum de documents (10) atteint pour cette conversation',
  chatProtocol: 'ProtocoleDeChat',
  uploadTooltip: 'Télécharger le fichier',
  uploadFilesTooltip: 'Télécharger des fichiers',
  pdfDownloadTooltip: 'Téléchargement de la conversation',
  showMore: 'Voir plus',
  showLess: 'Voir moins',
  feedbackDescription: 'Commentaires pour nous',
  feedbackSubtitle: {
    description:
      "Vous pouvez nous envoyer ici des suggestions, des propositions et des demandes d'ordre général.",
    note: 'Veuillez noter que nous ne pouvons pas y répondre.',
    hint:
      "Toutes les autres préoccupations qui concernent spécifiquement votre location ou la recherche d'un appartement peuvent nous être décrites dans le chat."
  },
  feedbackPlaceholder: 'Entrez votre message ici...',
  feedbackInfoPlaceholder: 'N\'hésitez pas à ajouter des détails spécifiques ici...',
  sendFeedback: 'Envoyer',
  giveFeedback: 'Commentaires pour nous',
  feedbackSubmittedSuccessfully: 'Votre commentaire a été soumis avec succès',
  character_limit: 'Caractères',
  page: 'p.',
  factually_incorrect: 'Pas factuellement correct',
  not_following_instructions: 'Instructions incomplètement suivies',
  info_not_in_document: 'Information non trouvée dans le document',
  inappropriate_or_offensive: 'Inapproprié ou offensant',
  irrelevant: 'Hors sujet',
  not_fitting_topic: 'Ne correspond pas au sujet',
  confusing_information: 'Information confuse',
  ignored_important_parts_of_document:
    'Parties importantes du document ignorées',
  interpreted_document_wrong: 'Interprétation incorrecte du document',
  answer_to_generic: 'Réponse trop générale',
  sources_incorrect: 'Sources non fiables ou citations incorrectes',
  why_not_helpful: 'Pourquoi cela n\'était-il pas utile ?',
  thank_you_feedback: 'Merci pour vos commentaires !',
  provide_feedback: 'Donner un feedback à cette réponse',
  not_helpful: 'Pas utile',
  helpful: 'Utile',
  regenerate_message: 'Régénérer',
  copy_message: 'Copier',
  copied_message: 'Copié !',
  copy_table_csv: 'Copier le tableau',
  download_table_csv: 'Télécharger CSV',
  expand_table: 'Ouvrir le tableau',
  print: 'Imprimer',
  original_answer: 'Réponse originale',
  regenerated_answer: 'Réponse régénérée',
  thinking_message: 'Je réfléchis...',
  file_path: 'Chemin du fichier : ',
  new_messages: 'Nouveaux messages',
  previous_message: 'Message précédent',
  next_message: 'Message suivant',
  clear_input: 'Effacer l\'entrée',
  open_feedback: 'Ouvrir les commentaires',
  file_upload: 'Téléchargement de fichier',
  expand_quickreplies_aria: 'Afficher plus de boutons',
  button_tooltip_switch_locale_german: 'Changer la langue en allemand',
  button_tooltip_switch_locale_french: 'Changer la langue en français',
  button_tooltip_switch_locale_dutch: 'Changer la langue en néerlandais',
  button_tooltip_switch_locale_turkish: 'Changer la langue en turc',
  button_tooltip_switch_locale_russian: 'Changer la langue en russe',
  button_tooltip_switch_locale_swedish: 'Changer la langue en suédois',
  button_tooltip_switch_locale_ukranian: 'Changer la langue en ukrainien',
  button_tooltip_switch_locale_spanish: 'Changer la langue en espagnol',
  button_tooltip_switch_locale_polish: 'Changer la langue en polonais',
  button_tooltip_switch_locale_arabic: 'Changer la langue en arabe',
  button_tooltip_switch_locale_italian: 'Changer la langue en italien',
  button_tooltip_switch_locale_english: 'Changer la langue en anglais',
  message_from_you: 'Vous dites',
  message_from_bot: 'Le bot dit',
  message_from_operator: 'L\'agent dit',
  new_message_from_bot: 'Le bot dit',
  empty_message_received: 'Message vide reçu',
  open_quick_actions: 'Ouvrir les actions rapides',
  quick_actions: 'Actions rapides',
  quick_actions_search_hint: '...ou continuez à taper pour des suggestions',
  quick_actions_no_results: 'Aucun résultat trouvé'
}
